<template>
  <div class="d-flex align-items-center text-center flex-column">
    <!-- 積點名稱/圖片 begin -->
    <div class="my-4">
      <h6 class="font-weight-normal text-mcf-color">
        {{ $t("qrcode.congratulations") }}
      </h6>
      <h3 class="font-weight-normal text-mcf-color">{{ coupon.couponName }}</h3>
      <div class="m-auto image-panel image-panel-5 bg-none my-2">
        <img :src="coupon.couponImg" alt="" />
      </div>
      <div class="text-mcf-color font-size-md">
        <div></div>
        <div class="mx-1">{{ couponlimit }}</div>
      </div>
    </div>
    <!-- 積點名稱/圖片 end -->
    <!-- 目前共收集 begin -->
    <div class="w-100 bg-gray200 py-3 px-2 rounded-md">
      <div class="mb-3">
        <span class="mx-1">{{ $t("qrcode.use-now") }}</span>
      </div>
      <div class="w-100 d-flex">
        <b-button
          class=" w-100 mx-2 bg-white "
           @click="callDynamicLogin('mcfwallet')"
          v-if="coupon.isOffline"
          :style="`color: rgba(${rGBaCode}); border-color: rgba(${rGBaCode})`"
          >{{ $t("qrcode.offline-use") }}</b-button
        >
        <b-button
          class=" w-100 mx-2 "
          @click="callDynamicLogin('shop')"
          v-if="coupon.isOnline"
          :style="`background: rgba(${rGBaCode}); border-color: rgba(${rGBaCode})`"
          >{{ $t("qrcode.go-shopping") }}</b-button
        >
      </div>
    </div>
    <!-- 目前共收集 end -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import format from 'date-fns/format';
import commonTool from '@/tools/commonTool';

export default {

  computed: {
    ...mapState([
      'memberAcntNo',
      'memberId',
      'limitEnd',
      'customerShopUrl',
      'companyId',
      'memberSourceId',
    ]),
    ...mapState('pmt', ['coupon']),
    ...mapState('sso', ['rGBaCode']),
    couponlimit() {
      if (this.coupon && this.coupon.limitType === 0) {
        return this.$t('qrcode.datelimit', { date: this.$t('qrcode-get-coupon.verification.receive-limit.no-limit') });
      }
      return this.$t('qrcode.datelimit', {
        date: `${format(this.limitEnd, 'yyyy/MM/dd HH:mm')} ${this.$t('qrcode.end')}`,
      });
    },
  },
  methods: {
    ...mapActions('sso', ['postDynamicLogin']),
    callDynamicLogin(destination) {
      const validData = {
        memberAcntNo: this.memberAcntNo,
        memberID: this.memberId,
      };

      if (commonTool.checkedMobile()) {
        validData.device = 'mobile';
      } else {
        validData.device = 'pc';
      }

      this.postDynamicLogin(validData).then((res) => {
        if (res && res.response.success) {
          if (destination === 'shop') {
            window.location.assign(
              `${this.customerShopUrl}Plugins/SSOAuth/LoginCallback?code=${res.response.data[0].code}`,
            );
          } else if (destination === 'mcfwallet') {
            window.location.assign(`${window.location.origin}/rewards/membercenter/mcfwallet?companyid=${this.companyId}&membersourceid=${this.memberSourceId}&code=${res.response.data[0].code}`);
          }
        }
      }, () => {
        if (destination === 'shop') {
          window.location.assign(this.customerShopUrl);
        } else if (destination === 'mcfwallet') {
          window.location.assign(`${window.location.origin}/rewards/membercenter/mcfwallet?companyid=${this.companyId}&membersourceid=${this.memberSourceId}`);
        }
      });
    },
  },
};
</script>

<style>
</style>
